import { getCookie } from 'cookies-next';
import { useCallback } from 'react';

import { parseToBool } from 'lib/string';

import COOKIES from 'constants/cookies';

const TOPBAR_AD_TYPE = 'TOP_AD';
const VISIBILITIES = {
  ALL: 'ALL',
  LOGGED_ONLY: 'LOGGED',
  UNLOGGED_ONLY: 'LOGGED_OUT',
};

export const useAdBanner = () => {
  const isAdBannerVisible = useCallback((ad) => {
    if (
      !('visibility' in ad) ||
      ad.visibility === VISIBILITIES.ALL ||
      // Ignores topbar ad visibility due performance issues during page
      ad.type === TOPBAR_AD_TYPE
    ) {
      return true;
    }

    const isUserLogged = parseToBool(getCookie(COOKIES.IS_USER_LOGGED));

    return (
      (ad.visibility === VISIBILITIES.UNLOGGED_ONLY && !isUserLogged) ||
      (ad.visibility === VISIBILITIES.LOGGED_ONLY && isUserLogged)
    );
  }, []);

  const getAdBannerWithHigherVisibilityPriority = useCallback(
    (ads, position = null) => {
      if (!ads || ads.length === 0) {
        return null;
      }

      let highPriorityAdBanner = null;
      const isUserLogged = parseToBool(getCookie(COOKIES.IS_USER_LOGGED));

      for (const ad of ads) {
        if (ad.type === TOPBAR_AD_TYPE) {
          highPriorityAdBanner = ad;
          break;
        }

        if (position !== null && position !== ad.position) {
          continue;
        }

        if (ad.visibility === VISIBILITIES.UNLOGGED_ONLY && !isUserLogged) {
          highPriorityAdBanner = ad;
          break;
        }

        if (ad.visibility === VISIBILITIES.LOGGED_ONLY && isUserLogged) {
          highPriorityAdBanner = ad;
          break;
        }

        highPriorityAdBanner = ad;
      }

      return highPriorityAdBanner;
    },
    []
  );

  return { isAdBannerVisible, getAdBannerWithHigherVisibilityPriority };
};

export default useAdBanner;
